































































import {Component, Vue, Inject} from 'vue-property-decorator';
import StationSelector from '../components/StationSelector.vue';
import {trainStore, engine} from '@/data/train-store';
import {Observer} from 'mobx-vue';
import AppBase from '@/components/AppBase.vue';
import DateSelector from '@/components/DateSelector.vue';
import HourSelector from '@/components/HourSelector.vue';
import LoadingOverlay from '@/components/LoadingOverlay.vue';
import {GTag} from '@/lib/google-analytics';

@Observer
@Component({
  components: {AppBase, StationSelector, DateSelector, HourSelector, LoadingOverlay}
})
export default class Search extends Vue {
  @Inject('$gtag') public readonly $gtag!: GTag;
  private search = trainStore.search;

  private get fromSuggestions() {
    return this.search.history.fromIds;
  }

  private get toSuggestions() {
    return this.search.history.toIds;
  }

  private onHourChange(hour: string) {
    engine.searchHourChange(hour);
  }

  private onDateChange(date: string) {
    engine.searchDateChange(date);
  }

  private onSearchClick(type: string) {
    this.$gtag.trackEvent('search', 0, type);
    switch (type) {
      case 'regular': {
        engine.search()
          .then(
            () => {
              this.$router.push('/search-results');
            },
            console.error.bind(console)
          );
        break;
      }
      case 'temp':
      case 'perm': {
        engine.addTrain(type === 'temp' ? Date.now() + (1000 * 60 * 60 * 24 * 3) : 0)
          .then(
            () => {
              this.$router.push('/');
            },
            console.error.bind(console)
          );
        break;
      }
    }
  }

  private onFromStationChange(stationId: string) {
    engine.searchFromStationChange(stationId);
  }

  private onToStationChange(stationId: string) {
    engine.searchToStationChange(stationId);
  }

  private swapStations() {
    const fromId = this.search.current.fromId;
    const toId = this.search.current.toId;
    engine.searchFromStationChange(toId);
    engine.searchToStationChange(fromId);
  }
}
